// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2Kbn-","emails":"CreateEditClinics_emails__1sOWt","emailTagLabel":"CreateEditClinics_emailTagLabel__1KwGk"};